function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    // Track the availability state of the last selected variant
    this.lastVariantAvailable = null;
  }

connectedCallback() {
  this.updateOptions(); // Ensure options are set
  this.updateMasterId(); // Ensure currentVariant is set
  this.checkVariantBanner(); // Check the banner immediately
   // Ensure Klaviyo has mounted
  requestAnimationFrame(() => {
    this.toggleAddButton();
  });
}


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
        this.toggleAddButton(); // Simplify toggle call
    this.updatePickupAvailability();
    this.removeErrorMessage();
        this.checkVariantBanner();

    
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      this.checkVariantBanner();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.checkVariantBanner();
      
    }
  }



  checkVariantBanner() {
    const targetVariantIds = [""]; // Replace with actual variant IDs
    const shippingBanner = document.getElementById("shippingNotifiction");
    const deliveryNote = document.getElementById("deliveryNote");
    const klaviyoFormSoldout = document.getElementById('klaviyo-form-soldout');


    if (this.currentVariant && targetVariantIds.includes(this.currentVariant.id.toString())) {
          // Extract selected size & color from options
        const selectedSize = this.currentVariant.options[0]; // Assuming size is the first option
        const selectedColor = this.currentVariant.options[1];  // Assuming color is the second option

        // Update banner text
        shippingBanner.innerHTML = `<span style="font-size: 12px;color: red;">PRE ORDER:<br>ORDERS CONTAINING ${selectedSize.toUpperCase()} ${selectedColor.toUpperCase()}<br>SHIPPED W/C 13.04</span>`;
        //shippingBanner.innerHTML = `<span style="font-size: 12px;color: red; text-transform:uppercase;">ARRIVES BEFORE <span style="background:black;color:white;">CHRISTMAS</span><br>LAST ORDERS:<br>→ 24hr shipping: 19th<br>→ 48hr shipping: 18th<br><br></span>`;
       //shippingBanner.innerHTML = `<span style="font-size: 12px;color: red; text-transform:uppercase;">Final Christmas orders:<br>Use 24hr Tracked before MIDDAY 22.12</span>`;
        shippingBanner.classList.remove("hidden");

      //deliveryNote.classList.add("hidden");
      deliveryNote.classList.remove("hidden");
    } else {
     // shippingBanner.classList.remove("hidden");
     shippingBanner.classList.add("hidden");
      deliveryNote.classList.add("hidden");
            //klaviyoFormSoldout.classList.remove("hidden");
    }
  }

  
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    this.checkVariantBanner();
  }

  updateMedia() {
    return;
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

toggleAddButton() {
  const productForm = document.getElementById(
    `product-form-${this.dataset.section}`
  );
  if (!productForm) return;

  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector('[name="add"] > span');
  const checkoutButton = productForm.querySelector('[name="checkoutBtn"]');
  const checkoutButtonText = checkoutButton?.querySelector('span'); 
  const klaviyoFormSoldout = productForm.querySelector('#klaviyo-form-soldout');



  if (!addButton || !checkoutButton) return;

  //  const isVariantAvailable = this.currentVariant?.available;

  
    // Check availability considering the 'continue selling when out of stock' option
    const isVariantAvailable = this.currentVariant?.available || this.currentVariant?.inventory_policy === "continue";

  
  // Exit early if availability hasn't changed
  if (isVariantAvailable === this.lastVariantAvailable) return;

  // Update button states based on availability
  if (isVariantAvailable) {
    addButton.removeAttribute("disabled");
    addButtonText.textContent = window.variantStrings.addToCart;
    checkoutButton.classList.remove("hidden"); // Show checkout button
    checkoutButtonText.textContent = "CHECKOUT";   
    
    //hide klaviyo form
    klaviyoFormSoldout?.classList.add("hidden");
 
  } else {
    addButton.setAttribute("disabled", "disabled");
    addButtonText.textContent = window.variantStrings.soldOut;
    checkoutButton.classList.add("hidden"); // Hide checkout button
    checkoutButtonText.textContent = "SOLD OUT";
        // Show Klaviyo form when sold out
    klaviyoFormSoldout?.classList.remove("hidden");

  }

  // Update the last known availability state
  this.lastVariantAvailable = isVariantAvailable;
}

setUnavailable() {
  const productForm = document.getElementById(
    `product-form-${this.dataset.section}`
  );
  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector('[name="add"] > span');
  const checkoutButton = productForm.querySelector('[name="checkoutBtn"]');
  const price = document.getElementById(`price-${this.dataset.section}`);
  const klaviyoFormSoldout = productForm.querySelector('#klaviyo-form-soldout');


  if (!addButton) return;

  addButton.setAttribute("disabled", "disabled");
  addButtonText.textContent = window.variantStrings.unavailable;

  if (price) price.classList.add("visibility-hidden");
  
  // Ensure checkout button is hidden
  checkoutButton.classList.add("hidden");
  klaviyoFormSoldout?.classList.remove("hidden");

  // Mark variant as unavailable
  this.lastVariantAvailable = false;
}



  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// ---  PROGRESS BAR JS ---
// --- PROGRESS BAR JS ---
window.cartUpsellHighlight = {
  line: null,
  action: null
};

function getActiveProgressSection() {
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

  if (currency === 'USD') {
    return document.getElementById('progressSectionUSD');
  }

  return document.getElementById('progressSectionDefault');
}

function getSockCount() {
  return parseInt(
    document.getElementById('sockCount')?.dataset.value || 0,
    10
  );
}

// Initial cart progress update
updateProgressBar();

// Monitor quantity change buttons dynamically
document.addEventListener('click', (e) => {
  if (e.target.closest('button[title="decrease quantity"], button[title="increase quantity"]')) {
  syncProgressSectionVisibility();

    updateProgressBar();
  }
});

// Fetch cart data and update progress bar
async function updateProgressBar() {
  try {
        syncProgressSectionVisibility();

    let progress = 0;
    const sockCount = getSockCount();
    const activeSection = getActiveProgressSection();

    if (!activeSection) return;

    if (sockCount >= 4) {
      progress = 100;
      updateSteps(4, activeSection);
    } else if (sockCount >= 3) {
      progress = 75;
      updateSteps(3, activeSection);
    } else if (sockCount === 2) {
      progress = 50;
      updateSteps(2, activeSection);
    } else if (sockCount === 1) {
      progress = 23;
      updateSteps(1, activeSection);
    } else {
      progress = 0;
      updateSteps(0, activeSection);
    }

    const progressBar = activeSection.querySelector(".progress-bar");
    if (progressBar) {
      progressBar.style.width = `${progress}%`;
    }
  } catch (error) {
    // console.error('Error updating cart progress:', error);
  }
}

function updateSteps(step, activeSection) {
  if (!activeSection) return;

  const steps = activeSection.querySelectorAll('.progress-steps .step');

  steps.forEach((stepElement, index) => {
    if (index < step) {
      stepElement.classList.add('active');
    } else {
      stepElement.classList.remove('active');
    }
  });
}

// Monitor cart changes and update
document.addEventListener('cart:updated', updateProgressBar);

const cartContainer = document.querySelector('.sums-cart');

if (cartContainer) {
  const observer = new MutationObserver(() => {
        syncProgressSectionVisibility();

    updateProgressBar();
  });

  observer.observe(cartContainer, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  function getSockLines() {
    return Array.from(document.querySelectorAll('.cart-line-item.is-sock'));
  }

  function getSockQty() {
    return getSockLines().reduce((total, line) => {
      return total + parseInt(line.dataset.qty || '0', 10);
    }, 0);
  }

  async function updateSockLineToTarget(targetQty) {
    const sockLines = getSockLines();
    if (!sockLines.length) return;

    const currentSockQty = getSockQty();
    const diff = targetQty - currentSockQty;

    if (diff === 0) return;

    window.dispatchEvent(new CustomEvent('cart-loading'));

    // INCREASES
    if (diff > 0) {
      const topSockLine = sockLines[0];
      const lineIndex = parseInt(topSockLine.dataset.line, 10);
      const currentLineQty = parseInt(topSockLine.dataset.qty || '0', 10);
      const newQty = currentLineQty + diff;

      window.cartUpsellHighlight.line = lineIndex;
      window.cartUpsellHighlight.action = 'plus';

      if (typeof Sunrise !== 'undefined' && typeof Sunrise.updateQuantity === 'function') {
        Sunrise.updateQuantity(lineIndex, newQty);
        setTimeout(() => {
          reapplyUpsellHighlight();
          updateProgressBar();
        }, 400);
      }

      return;
    }

    // DECREASES
    clearUpsellHighlights();

    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      let amountToRemove = Math.abs(diff);
      const updates = {};

      sockLines.forEach((lineEl) => {
        const lineIndex = parseInt(lineEl.dataset.line, 10);
        const item = cart.items[lineIndex - 1];

        if (!item) return;

        const currentQty = item.quantity;
        let newQty = currentQty;

        if (amountToRemove > 0) {
          const removeFromThisLine = Math.min(currentQty, amountToRemove);
          newQty = currentQty - removeFromThisLine;
          amountToRemove -= removeFromThisLine;
        }

        updates[item.key] = newQty;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      window.dispatchEvent(new CustomEvent('cart-updated'));
        syncProgressSectionVisibility();

      setTimeout(updateProgressBar, 150);
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  document.addEventListener('click', (e) => {
    const step = e.target.closest('.progress-step');
    if (step) {
      const targetQty = parseInt(step.dataset.target, 10);
      updateSockLineToTarget(targetQty);
      return;
    }

    if (
      e.target.closest('.cartQtyButton') ||
      e.target.closest('.sums-cart-remove')
    ) {
      clearUpsellHighlights();
    }
  });

  document.addEventListener('cart:updated', () => {
      syncProgressSectionVisibility();

    setTimeout(() => {
      reapplyUpsellHighlight();
      updateProgressBar();
    }, 150);

  });

  updateProgressBar();
});

function clearUpsellHighlights() {
  window.cartUpsellHighlight = {
    line: null,
    action: null
  };

  document
    .querySelectorAll('.cartQtyButton--plus.upsell-updated, .cartQtyButton--minus.upsell-updated')
    .forEach(el => el.classList.remove('upsell-updated'));
}

function reapplyUpsellHighlight() {
  const state = window.cartUpsellHighlight;
  if (!state || !state.line || !state.action) return;

  document
    .querySelectorAll('.cartQtyButton--plus.upsell-updated, .cartQtyButton--minus.upsell-updated')
    .forEach(el => el.classList.remove('upsell-updated'));

  const line = document.querySelector('.cart-line-item[data-line="' + state.line + '"]');
  if (!line) return;

  const targetBtn = line.querySelector(
    state.action === 'plus'
      ? '.cartQtyButton--plus'
      : '.cartQtyButton--minus'
  );

  if (targetBtn) {
    targetBtn.classList.add('upsell-updated');
  }
}

function getCurrencyCode() {
  return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
}

function syncProgressSectionVisibility() {
  const currency = getCurrencyCode();
  const isUSD = currency === 'USD';

  const defaultSection = document.getElementById('progressSectionDefault');
  const usdSection = document.getElementById('progressSectionUSD');

  if (!defaultSection || !usdSection) return;

  if (isUSD) {
    defaultSection.style.display = 'none';
    usdSection.style.display = 'block';
  } else {
    defaultSection.style.display = 'block';
    usdSection.style.display = 'none';
  }
}

function getActiveProgressSection() {
  syncProgressSectionVisibility();

  const currency = getCurrencyCode();
  return currency === 'USD'
    ? document.getElementById('progressSectionUSD')
    : document.getElementById('progressSectionDefault');
}
// --- PROGRESS BAR JS ENDS ---

// --- UPSELL SECTION JS STARTS ---



  (function () {
    function getUpsellRoot() {
      return document.getElementById('cart-upsell');
    }

    function getMostCommonCartSize(upsell) {
      if (!upsell) return '';

      var titlesRaw = upsell.dataset.cartVariantTitles || '';
      if (!titlesRaw) return '';

      var titles = titlesRaw
        .split('|||')
        .map(function (item) { return item.trim(); })
        .filter(Boolean);

      var counts = {};

      titles.forEach(function (title) {
        var parts = title.split(' / ');
        if (!parts.length) return;

        var maybeSize = (parts[0] || '').trim();
        if (!maybeSize) return;

        counts[maybeSize] = (counts[maybeSize] || 0) + 1;
      });

      var topSize = '';
      var topCount = 0;

      Object.keys(counts).forEach(function (size) {
        if (counts[size] > topCount) {
          topSize = size;
          topCount = counts[size];
        }
      });

      return topSize;
    }

    function setDefaultUpsellSizes(upsell) {
      if (!upsell) return;

      var preferredSize = getMostCommonCartSize(upsell);
      if (!preferredSize) return;

      upsell.querySelectorAll('.cart-upsell__select').forEach(function (select) {
        var matched = Array.from(select.options).find(function (opt) {
          return (opt.dataset.size || '').toLowerCase() === preferredSize.toLowerCase();
        });

        if (matched) {
          select.value = matched.value;
        }
      });
    }

    function sortCardsByOrder(upsell) {
      if (!upsell) return;

      var track = upsell.querySelector('.cart-upsell__track');
      if (!track) return;

      var cards = Array.from(track.querySelectorAll('.cart-upsell__card'));
      if (!cards.length) return;

      cards.sort(function (a, b) {
        var aOrder = parseInt(a.dataset.order || '999', 10);
        var bOrder = parseInt(b.dataset.order || '999', 10);
        return aOrder - bOrder;
      });

      cards.forEach(function (card) {
        track.appendChild(card);
      });
    }

    function bindArrowNav(upsell) {
      if (!upsell || upsell.dataset.navBound === 'true') return;

      var trackWrap = upsell.querySelector('.cart-upsell__track-wrap');
      var prevBtn = upsell.querySelector('.cart-upsell__arrow--prev');
      var nextBtn = upsell.querySelector('.cart-upsell__arrow--next');
      var firstCard = upsell.querySelector('.cart-upsell__card');

      if (!trackWrap || !prevBtn || !nextBtn || !firstCard) return;

      function getStep() {
        var gap = 12;
        var track = upsell.querySelector('.cart-upsell__track');

        if (track) {
          var trackStyles = window.getComputedStyle(track);
          gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '12') || 12;
        }

        return firstCard.getBoundingClientRect().width + gap;
      }

      prevBtn.addEventListener('click', function () {
        trackWrap.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        trackWrap.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      upsell.dataset.navBound = 'true';
    }

    function initCartUpsell() {
      var upsell = getUpsellRoot();
      if (!upsell) return;

      sortCardsByOrder(upsell);
      setDefaultUpsellSizes(upsell);
      bindArrowNav(upsell);
    }

    function handleUpsellAdd(addBtn) {
      if (!addBtn || addBtn.classList.contains('is-loading')) return;

      var card = addBtn.closest('.cart-upsell__card');
      if (!card) return;

      var select = card.querySelector('.cart-upsell__select');
      if (!select || !select.value) return;

      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Adding...';

      window.dispatchEvent(new CustomEvent('cart-loading'));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(select.value),
          quantity: 1,
          properties: {
        _cart_upsell: 'true'
        }
        })
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to add upsell item');
        return response.json();
      })
      .then(function () {
  var card = addBtn.closest('.cart-upsell__card');
  var select = card ? card.querySelector('.cart-upsell__select') : null;
  var selectedOption = select ? select.options[select.selectedIndex] : null;

  var productId = card ? card.dataset.productId : '';
  var productTitle = card ? card.dataset.productTitle : '';
  var colour = card ? card.dataset.colour : '';
  var currency = card ? card.dataset.currency : '';
  var priceMinor = card ? parseInt(card.dataset.price || '0', 10) : 0;
  var price = priceMinor / 100;
  var variantId = selectedOption ? selectedOption.value : '';
  var size = selectedOption ? (selectedOption.dataset.size || selectedOption.text || '') : '';

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'cart_upsell_add',
    upsell_location: 'cart_drawer',
    product_id: productId,
    variant_id: variantId,
    product_name: productTitle,
    product_colour: colour,
    product_size: size,
    currency: currency,
    value: price,
    quantity: 1
  });
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      currency: currency,
      value: price,
      items: [
        {
          item_id: String(variantId),
          item_name: productTitle,
          item_variant: [colour, size].filter(Boolean).join(' / '),
          price: price,
          quantity: 1,
          item_category: 'Cart Upsell',
          item_brand: 'SUMS',
          item_list_name: 'Cart Upsell'
        }
      ]
    }
  });

  window.dispatchEvent(new CustomEvent('cart-updated'));
  window.dispatchEvent(new CustomEvent('cart-bounce'));
})
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        addBtn.classList.remove('is-loading');
        addBtn.textContent = 'Add to cart';
      });
    }

    if (!window.__cartUpsellDelegatedBind) {
      window.__cartUpsellDelegatedBind = true;

      document.addEventListener('pointerup', function (event) {
        var addBtn = event.target.closest('[data-add-upsell]');
        if (!addBtn) return;

        event.preventDefault();
        event.stopPropagation();
        handleUpsellAdd(addBtn);
      }, true);
    }

    if (!window.__cartUpsellObserverBound) {
      window.__cartUpsellObserverBound = true;

      var observer = new MutationObserver(function () {
        var upsell = getUpsellRoot();
        if (!upsell) return;

        if (upsell.dataset.initialised === 'true') return;

        initCartUpsell();
        upsell.dataset.initialised = 'true';
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    window.initCartUpsell = function () {
      var upsell = getUpsellRoot();
      if (!upsell) return;

      initCartUpsell();
      upsell.dataset.initialised = 'true';
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.initCartUpsell();
      });
    } else {
      window.initCartUpsell();
    }

    window.addEventListener('cart-drawer:opened', function () {
      setTimeout(function () {
        var upsell = getUpsellRoot();
        if (!upsell) return;
        upsell.dataset.initialised = 'false';
        window.initCartUpsell();
      }, 100);
    });

    window.addEventListener('cart-updated', function () {
      setTimeout(function () {
        var upsell = getUpsellRoot();
        if (!upsell) return;
        upsell.dataset.initialised = 'false';
        window.initCartUpsell();
      }, 150);
    });
  })();
